import { useCallback, useState } from 'react';
import validate from 'validate.js';
import { getObjectValue, objToArray, toString } from 'utilities';
import { FormConstraints, FormState, FormValues } from './types';

const useFormValidation = (constraints: FormConstraints) => {
  const [formValidated, setFormValidated] = useState<FormState<FormValues>>({
    errors: {},
    isValid: false,
    values: {},
  });

  const validateForm = useCallback(
    (values: FormValues) => {
      const currentValues: Partial<FormValues> = getObjectValue(values);
      const deletedFields: Partial<FormValues> = {};

      objToArray(currentValues).forEach(([prop, value]) => {
        if (toString(value).length) {
          currentValues[prop] = value;
        } else {
          deletedFields[prop] = value;
          delete currentValues[prop];
        }
      });

      const errors = validate(currentValues, constraints);

      setFormValidated({
        errors: getObjectValue(errors),
        isValid: Boolean(!errors),
        values: { ...currentValues, ...deletedFields },
      });
    },
    [constraints]
  );

  return { formValidated, validateForm };
};

export default useFormValidation;
